import { JobPositionShift } from '@restworld/utility-types';
import { fullWeekType } from './job-shifts.types';

const fromWord = 'da';
const andWord = 'e';
const toWord = 'a';
const shiftNotes = `Viene offerta la possibilità di arrivare un po' prima a lavoro per pranzare/cenare nel locale.`;
const jobType = 'full time (40 ore settimanali)';
const category = 'Doppio turno';
/*
  category --> it is a string (chosen between multiple available values)
  category_other --> free string value, which is present only if none of the above options was fit to the job position.
  days_per_week_number --> integer values indicating how many days the person will have to work in the given shift
  days_per_week --> The list of specific days the person will have to work in this shift
*/
const shiftsDouble: JobPositionShift[] = [
  {
    category,
    days_per_week: ['mo', 'tu', 'we', 'sa', 'su'],
  },
  {
    hours: [
      {
        start_at: '11',
        end_at: '17',
      },
    ],
    days_per_week_number: 2,
  },
];
const shiftSingleWithCategory: JobPositionShift[] = [
  {
    days_per_week: ['mo', 'th'],
  },
];
const shiftSingleWithoutCategory: JobPositionShift[] = [
  {
    category_other: 'Any other category',
    days_per_week: ['mo', 'th'],
  },
];
/*
  daysRequiredPerWeekNumber --> integer values indicating how many days per week the person will work
  daysRequiredPerWeek --> optional list of days that the person will need to work
*/
const withDaysRequiredPerWeekNumberArgs = {
  jobType,
  daysRequiredPerWeekNumber: 5,
  shifts: [...shiftsDouble],
  shift_notes: shiftNotes,
};
const withDaysRequiredPerWeekArgs = {
  jobType,
  daysRequiredPerWeek: ['mo', 'fr'],
  shifts: [...shiftsDouble],
  shiftNotes,
};
const emptyWorkingDaysArgs = {
  jobType,
  shifts: [...shiftsDouble],
  shiftNotes,
};
const emptyShiftsArgs = {
  daysRequiredPerWeekNumber: 5,
  daysRequiredPerWeek: ['mo', 'fr'],
  jobType,
  shiftNotes,
};
const shiftsWithJustCategoryArgs = {
  jobType,
  daysRequiredPerWeekNumber: 5,
  shifts: [...shiftSingleWithCategory],
  shiftNotes,
};
const shiftsWithOutCategoryArgs = {
  jobType,
  daysRequiredPerWeekNumber: 5,
  shifts: [...shiftSingleWithoutCategory],
  shiftNotes,
};
const weekDayMap = {
  mo: 'lunedì',
  tu: 'martedì',
  we: 'mercoledì',
  th: 'giovedì',
  fr: 'venerdì',
  sa: 'sabato',
  su: 'domenica',
};
const weekDaySymbol = Object.keys(weekDayMap);
const fullWeek: fullWeekType = { mo: 1, tu: 2, we: 3, th: 4, fr: 5, sa: 6, su: 7 };
export {
  withDaysRequiredPerWeekArgs,
  withDaysRequiredPerWeekNumberArgs,
  emptyShiftsArgs,
  emptyWorkingDaysArgs,
  shiftsWithJustCategoryArgs,
  shiftsWithOutCategoryArgs,
  weekDayMap,
  weekDaySymbol,
  fromWord,
  andWord,
  toWord,
  fullWeek,
};
